import { render } from "./LogrosES.vue?vue&type=template&id=26f05900&scoped=true"
import script from "./LogrosES.vue?vue&type=script&lang=js"
export * from "./LogrosES.vue?vue&type=script&lang=js"

import "./LogrosES.vue?vue&type=style&index=0&id=26f05900&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f05900"]])

export default __exports__